<template>
  <div>
    <banner-section :bannerList="bannerList" @playNstop="autoStart" :windowWidth="windowWidth"/>
    <div id="GoContent">
      <products-section :product-list="productList"/>
      <brand-film :main-video="mainVideo"/>
      <brand-story />
      <latest-news :newsList="newsList" @move-to-detail="moveToDetail" />
      <sns-section :instaList="instaList" />
    </div>
    <popup v-if="checkCookiePopup" :popupList="popupList" :windowWidth="windowWidth"/>
  </div>
</template>

<script>
// 병헌 : 슬라이더 플러그인 (https://swiperjs.com/swiper-api)
import Swiper from '@/assets/plugins/swiper.min';
import '@/assets/plugins/swiper.min.css';
// import ResponseMenu from '@/components/header/ResponseMenu.vue';
/* 병헌 : 웹접근성 반복되는 콘텐츠 뛰어넘는 메뉴 (주메뉴 바로가기, 본문 바로가기, 글로벌 메뉴 바로가기) */
import bannerApi from '@/apis/banner';
import snsApi from '@/apis/sns';
import newsApi from '@/apis/news';
import productAPi from '@/apis/product';
import { log } from '@/utils/common';
import BannerSection from './partial/BannerSection.vue';
import ProductsSection from './partial/product/ProductsSection.vue';
import BrandStory from './partial/BrandStory.vue';
import BrandFilm from './partial/BrandFilm.vue';
import LatestNews from './partial/LatestNews.vue';
import SnsSection from './partial/sns/SnsSection.vue';
import Popup from './partial/Popup.vue';

export default {
  name: 'Home',
  components: {
    BannerSection,
    ProductsSection,
    BrandStory,
    BrandFilm,
    LatestNews,
    SnsSection,
    Popup,
  },
  computed: {
    checkCookiePopup() {
      const cookie = this.$cookies.get('hidePopup');
      if (cookie != null && cookie === 'true') {
        return false;
      }
      return true;
    },
  },
  data() {
    return {
      isM: false /* 병헌 : 모바일 네비게이션 열고 닫는 변수, true면 열림 */,
      slide: Swiper /* 병헌 : 상단 비주얼 슬라이드 */,
      slide2: Swiper /* 병헌 : INCELLDERM Products 슬라이드 */,
      slide3: Swiper /* 병헌 : INCELLDERM Products2 슬라이드 */,
      slide4: Swiper /* 병헌 : Latest news 슬라이드 */,
      slide5: Swiper /* 병헌 : #INCELLDERM SNS 인스타 슬라이드 */,
      slide6: Swiper /* 병헌 : #INCELLDERM SNS 유튜브 슬라이드 */,
      bannerList: [],
      instaList: [],
      newsList: [],
      popupList: [],
      productList: [],
      mainVideo: {},
      windowWidth: document.body.clientWidth,
    };
  },
  // components: {
  //   ResponseMenu /* 병헌 : 웹접근성 반복되는 콘텐츠 뛰어넘는 메뉴 (주메뉴 바로가기, 본문 바로가기, 글로벌 메뉴 바로가기) */
  // },
  created() {
    this.init();
  },
  async mounted() {
    this.$nextTick(() => {
      // eslint-disable-next-line func-names
      window.addEventListener('resize', () => {
        this.windowWidth = document.body.clientWidth;
        // this.slide.destroy();
        // this.setMainBanner();
      });
    });
    this.slide2 = new Swiper('.slide2', {
      observer: true,
      observeParents: true,
      observeSlideChildren: true,
      updateOnWindowResize: true,
      renderExternalUpdate: true,
      speed: 1000,
      slidesPerView: 4,
      navigation: {
        nextEl: '.slide2 .swiper-button-next',
        prevEl: '.slide2 .swiper-button-prev',
      },
      pagination: {
        el: '.slide2 .swiper-pagination',
        type: 'fraction',
      },
      scrollbar: {
        el: '.slide2 .swiper-scrollbar',
        dragSize: 'auto',
      },
      breakpoints: {
        600: {
          slidesPerView: 1,
        },
      },
    });
    this.slide3 = new Swiper('.slide3', {
      observer: true,
      observeParents: true,
      observeSlideChildren: true,
      slidesPerView: 3,
      loop: false,
      spaceBetween: '37',
      simulateTouch: true,
      breakpoints: {
        600: {
          spaceBetween: 16,
          slidesPerView: 'auto',
          centeredSlides: true,
          simulateTouch: true,
        },
      },
    });
    this.slide4 = new Swiper('.slide4', {
      observer: true,
      observeParents: true,
      observeSlideChildren: true,
      slidesPerView: 5,
      loop: false,
      spaceBetween: 40,
      simulateTouch: true,
      initialSlide: 1,
      breakpoints: {
        600: {
          spaceBetween: 16,
          slidesPerView: 'auto',
          loop: false,
          centeredSlides: true,
        },
        768: {
          spaceBetween: 22,
          slidesPerView: 2.5,
          loop: false,
          centeredSlides: true,
          initialSlide: 1,
        },
      },
    });
    this.slide5 = new Swiper('.slide5', {
      observer: true,
      observeParents: true,
      observeSlideChildren: true,
      slidesPerView: 4,
      loop: false,
      spaceBetween: 40,
      simulateTouch: true,
      breakpoints: {
        600: {
          spaceBetween: 16,
          slidesPerView: 'auto',
          loop: true,
          centeredSlides: true,
          simulateTouch: true,
        },
      },
    });
    this.slide6 = new Swiper('.slide6', {
      observer: true,
      observeParents: true,
      observeSlideChildren: true,
      slidesPerView: 4,
      loop: false,
      spaceBetween: 40,
      simulateTouch: false,
      breakpoints: {
        600: {
          spaceBetween: 16,
          slidesPerView: 'auto',
          loop: true,
          centeredSlides: true,
          simulateTouch: true,
        },
      },
    });
  },
  methods: {
    init() {
      this.getProductList();
      this.getBannerList();
      this.getNewsList();
      this.getInstaList();
      this.getPopupList();
      this.getMainVideo();
    },
    // 병헌 : 모바일 네비게이션 열렸을 때 바탕 스크롤 방지
    isMNavi() {
      if (this.isM) {
        document.querySelector('body').classList.add('hide-overflow');
      } else {
        document.querySelector('body').classList.remove('hide-overflow');
      }
    },
    // 병헌 : 상단 비주얼 슬라이드 플레이/정지 변수
    autoStart(val) {
      if (val) {
        this.slide.autoplay.start();
        this.slideStat = true;
      } else {
        this.slide.autoplay.stop();
        this.slideStat = false;
      }
    },
    async getBannerList() {
      const bannerData = await bannerApi.getBannerList();
      if (bannerData.error) {
        log('bannerApi::getBannerList', 'error', bannerData.error);
        return;
      }
      this.bannerList = bannerData;
      this.setMainBanner();
    },
    setMainBanner() {
      setTimeout(() => {
        this.slide = new Swiper('.slide1', {
          observer: true,
          observeParents: true,
          observeSlideChildren: true,
          speed: 500,
          height: 600,
          lazy: true,
          effect: 'fade',
          loop: false,
          autoplay: {
            delay: 3000,
            disableOnInteraction: false,
          },
          navigation: {
            nextEl: '.slide1 .swiper-button-next',
            prevEl: '.slide1 .swiper-button-prev',
          },
          pagination: {
            el: '.slide1 .swiper-pagination',
            type: 'fraction',
          },
          breakpoints: {
            600: {
              // pagination: false,
              // navigation: false,
              height: '100vh',
              scrollbar: {
                el: '.slide1 .btn_controllLR .swiper-scrollbar',
                hide: false,
                dragSize: 'auto',
              },
            },
          },
        });
      }, 1);
    },
    async getInstaList() {
      const instaData = await snsApi.getinstaList(4);
      if (instaData.error) {
        log('newsApi::getNewsDetail', 'error', instaData.error);
        return;
      }
      this.instaList = instaData;
    },
    async getNewsList() {
      this.newsList = [];
      const newsData = await newsApi.getNewsList('', 5, 1);
      if (newsData.error) {
        log('newsApi::getNewsDetail', 'error', newsData);
        return;
      }
      this.newsList = newsData.list;
    },
    async getPopupList() {
      this.popupList = [];
      const popupData = await bannerApi.getPopupList();
      if (popupData.error) {
        log('bannerApi::getPopupList', 'error', popupData);
        return;
      }
      this.popupList = popupData;
      if (this.popupList.length > 0) {
        this.$root.$emit('bv::show::modal', 'popup');
      }
    },
    moveToDetail(newsId) {
      this.$router.push({
        name: 'NewsDetail',
        params: { newsId },
      });
    },
    async getProductList() {
      const result = await productAPi.getMainProductList();
      if (!result.error) {
        this.productList = result;
      }
    },
    async getMainVideo() {
      const result = await snsApi.getMainVideo();
      if (!result.error) {
        this.mainVideo = result;
      }
    },
  },
};
</script>

<style lang="scss" scoped>
@import "@/assets/css/main.scss";
</style>
